module.exports = __webpack_public_path__ + "static/media/bells.4fde9a72.svg";